export default __webpack_public_path__ + "static/img69h-d293f6b83bab1a2e3c2b5631f6334e80.jpg";